import { useAppSelector } from '@/hooks';
import { RootState } from '@/store';
import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from '@/components/common/LoadingSpinner';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowPasswordChange?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowPasswordChange = false }) => {
    const { isAuthenticated, isInitializing, mustChangePassword } = useAppSelector((state: RootState) => state.auth);

    // If user is authenticated in Redux state, allow access
    if (isAuthenticated) {
        if (allowPasswordChange) {
            if (!mustChangePassword) {
                return <Navigate to="/student/dashboard" replace />;
            }
            return <>{children}</>;
        }
        if (mustChangePassword) {
            return <Navigate to="/change-password-required" replace />;
        }
        return <>{children}</>;
    }
    
    // A cookie session may exist: wait for /auth/user/ before deciding (EAA-2090)
    if (isInitializing) {
        return <LoadingSpinner />;
    }

    // Not authenticated, redirect to login
    return <Navigate to="/auth/login" replace />;
};

export default ProtectedRoute;
